import TeamSvg from './TeamIcon.svg?react'

import styles from '@/pages/app/Usage/styles.module.scss'

const TeamIcon = () => <TeamSvg className={styles.icon} />

export default TeamIcon
